import React from 'react';
import { mount } from 'enzyme';
import NumberFormats from '../NumberFormats';


const props = {
    handleValueChange: jest.fn(),
    fieldId: 'test',
    answer: 'test',
    isRequired: true,
  handleFieldErrorChanged: jest.fn(),
  updateFieldErrors: jest.fn()
};


describe('NumberFormats', () => {
    it('should render the NumberFormats component correctly', () => {
      const wrapper = mount(<NumberFormats {...props} />);
       expect(wrapper).toMatchSnapshot();
    });

    it('NumberFormats', () => {
        const wrapper = mount(
          <NumberFormats />
        );
        expect(wrapper.find('input'));
      });

      it('should not render Select NumberFormats when customField is false', () => {
        const wrapper = mount(
          <NumberFormats customField={false} options={[]} answer={''} fieldId={'field1'} />
        );
        expect(wrapper.find('Select').length);
      });

      it('should not render Select NumberFormats when customField is true', () => {
        const wrapper = mount(
          <NumberFormats customField options={[]} answer={''} fieldId={'field1'} />
        );
        expect(wrapper.find('Select').length);
      });

         it('should update errors and call props functions correctly when value is blank', () => {
        const handleValueChangeMock = jest.fn();
        const handleFieldErrorChangedMock = jest.fn();
        const updateFieldErrorsMock = jest.fn();
        const props = {
          handleValueChange: handleValueChangeMock,
          handleFieldErrorChanged: handleFieldErrorChangedMock,
          updateFieldErrors: updateFieldErrorsMock,
          isRequired: true
        };

        const wrapper = mount(<NumberFormats {...props} />);
        const instance = wrapper.instance();
           instance.handleAnswerChanged('', 'someFieldId');
     expect(handleFieldErrorChangedMock).toHaveBeenCalledWith('someFieldId', true);
      });
    });
